import {
    Button,
    Dialog,
    DialogTitle,
    Flex,
    Input,
    Text
} from '@priority-software/priority-style-react';
import React, {useState} from 'react';
import {FileFields} from '../consts';
import {getFieldObjValueByName, getFieldValueByName} from '../../Common/utils';
import texts from '../../texts';
import styles from '../styles/renameDialog.module.scss';
import {isRTL} from '../../../../../../Localization';
import {Column} from '../../../../../../stores/Form/Column';
import {keys} from '../../../../../../constants/KeyCodes';
import {getClipboardData} from '../../../../utils/pasteToColumn';
import {createDataTestId} from '../../../../../../utils/dataTestId';

export const RenameDialog = ({onClose, file, onSave}) => {
    const [value, setValue] = useState(getFieldValueByName(file, FileFields.fileName).toString());

    const onApprove = () => {
        onSave(FileFields.fileName, value);
        onClose();
    };

    return (
        <Dialog
            width={320}
            isOpen
            onClose={onClose}
            title={<DialogTitle title={texts.rename} />}
            content={
                <RenameDialogContent
                    file={file}
                    value={value}
                    setValue={setValue}
                    onApprove={onApprove}
                />
            }
            footer={<RenameDialogFooter onClose={onClose} value={value} onApprove={onApprove} />}
        />
    );
};

const RenameDialogFooter = ({onClose, onApprove, value}) => {
    return (
        <Flex>
            <Button skin="primary" onClick={onApprove} disabled={!value?.length}>
                {texts.rename}
            </Button>
            <Button skin="secondary" onClick={onClose}>
                {texts.cancel}
            </Button>
        </Flex>
    );
};

const getInputMaxLength = (file): number => {
    const column: Column = file.parentForm.getColumnByName(FileFields.fileName);
    return column?.maxLength;
};

const RenameDialogContent = ({file, value, setValue, onApprove}) => {
    const extension = getFieldObjValueByName(file, FileFields.fileData)?.File?.Extension;

    const handleKeyDown = (event: React.KeyboardEvent) => {
        const {key} = event;
        if (key === keys.ENTER) {
            event.stopPropagation();
            event.preventDefault();
            onApprove();
        }
    };

    return (
        <Flex componentClasses={styles.renameBlock}>
            <Input
                onPaste={event => setValue(getClipboardData(event))}
                value={value}
                onChange={event => setValue(event.target.value)}
                onKeyDown={handleKeyDown}
                componentClasses={styles.renameInput}
                maxLength={getInputMaxLength(file)}
                autoFocus
                autoSelect
            />
            <Text
                skin="paragraph-2"
                startPadding={!isRTL()}
                endPadding={isRTL()}
                {...createDataTestId(`attachments-rename-extension`, true)}
            >
                {extension}
            </Text>
        </Flex>
    );
};
